module.exports = __webpack_public_path__ + "img/video-dangan.7021a911.jpg";